import { ReactElement, useState } from 'react';
import { Field, useFormikContext } from 'formik';
import { FileUploadGroupAccessible, LimitedTextAreaLarge } from '@components';
import { iNominationFormValues } from '@services/NominationService';
import { FormType } from '@constants';

function NominationStep10(): ReactElement {
  const { values }: { values: iNominationFormValues } = useFormikContext();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [loading, setLoading] = useState(false);
  const notMarine = ['vehicle', 'driving the vehicle'];
  const marine = ['vessel', 'in control of the vessel'];
  const filteredData = values.IsMarineOffence ? marine : notMarine;
  return (
    <>
      {!loading && (
        <>
          <div className="vfH2">You cannot identify who was in possession of the {filteredData[0]} at the time of the offence</div>
          <p>Please tell us how you have tried to identify the person responsible for the offence. Your application may be rejected if you do not provide sufficient evidence. <br /><br />Not knowing who was {filteredData[1]} at the time of the offence is not an adequate reason, unless you can prove you were not responsible and cannot identify the person responsible, despite taking reasonable steps to do so. <br /><br />It is an offence with serious maximum penalties to knowingly provide false or misleading information.</p>
          <div style={{ marginBottom: '1em' }}>
            <Field component={LimitedTextAreaLarge} name="UnableToIdentifyExplanation" limit={3000} isMandatory />
          </div>
          <span>Attach any supporting documents (maximum of {values.FileUploadMaxAttachmentsConfig} files; each file should be less than {values.FileUploadSizeConfig}MB</span>
          <FileUploadGroupAccessible
            uploadAReport="UnableToIdentifyNameField"
            uploadFieldArrayName="UnableToIdentify"
            whoPrepared="UnableToIdentifyProvider"
            briefDescription="UnableToIdentifyDescription"
            fileSizeErrorField="UnableToIdentifySizeErrorHandle"
            fileUploadFailErrorField="UnableToIdentifyFileUploadErrorHandle"
            UploadFileSectionError="UnableToIdentifyFileSectionError"
            fileSizelimit={values.FileUploadSizeConfig.toString()}
            totalFileLimit={values.FileUploadMaxAttachmentsConfig}
            hasPrepared={false}
            hasDescribe={false}
            formType={FormType.NOMINATION} />
        </>
      )}
    </>
  );
}

export default NominationStep10;
